import createVueComponent from '../createVueComponent';

const Forward = createVueComponent('ForwardIcon', [
  ['polyline', { points: '15 17 20 12 15 7', key: '1w3sku' }],
  ['path', { d: 'M4 18v-2a4 4 0 0 1 4-4h12', key: 'jmiej9' }],
]);

export default Forward;
